var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { themeGet } from '@styled-system/theme-get';
import React, { memo, useMemo } from 'react';
import styled from 'styled-components';
import { Box, getPaletteColor } from 'pcln-design-system';
import monthNameBuilder from '../utils/monthNameBuilder/monthNameBuilder';
var MonthNameBox = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &&& {\n    font-size: ", "px;\n    font-weight: ", ";\n\n    color: ", ";\n    text-transform: capitalize;\n\n    ", " {\n      ", "\n    }\n  }\n"], ["\n  &&& {\n    font-size: ", "px;\n    font-weight: ", ";\n\n    color: ", ";\n    text-transform: capitalize;\n\n    ", " {\n      ", "\n    }\n  }\n"])), function (props) { return props.theme.fontSizes[props.use2024DesignSeti ? 3 : 2]; }, function (props) { return props.theme.bold; }, function (props) { return getPaletteColor(props.use2024DesignSeti ? 'primary.dark' : 'text.light')(props); }, themeGet('mediaQueries.md'), function (props) {
    return !props.use2024DesignSeti &&
        "\n        color: ".concat(getPaletteColor('text.dark')(props), " !important;\n        background: ").concat(getPaletteColor('background.lightest')(props), " !important;\n      ");
});
function MonthName(_a) {
    var displayYear = _a.displayYear, locale = _a.locale, monthIndex = _a.monthIndex, use2024DesignSeti = _a.use2024DesignSeti, year = _a.year, props = __rest(_a, ["displayYear", "locale", "monthIndex", "use2024DesignSeti", "year"]);
    var memoizedMonthNames = useMemo(function () { return monthNameBuilder({ format: 'wide', locale: locale })[monthIndex]; }, [locale]);
    return (React.createElement(MonthNameBox, __assign({}, props, { borderRadius: 'lg', color: !use2024DesignSeti && 'background.light', textAlign: use2024DesignSeti ? ['left', null, 'center'] : 'center', use2024DesignSeti: use2024DesignSeti, py: 2 }),
        memoizedMonthNames,
        displayYear && " ".concat(year)));
}
export default memo(MonthName);
var templateObject_1;
//# sourceMappingURL=MonthName.js.map